import { render } from "./ThumbnailElement.vue?vue&type=template&id=36b099d8&ts=true"
import script from "./ThumbnailElement.vue?vue&type=script&lang=ts"
export * from "./ThumbnailElement.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__